import { CheckCircle, Circle, Eye, FileUp, Trash2 } from 'lucide-react'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

import { LoaderCircle } from '../loader-circle'

interface FormRootProps extends ComponentProps<'form'> {}
function formRoot({ className, ...props }: FormRootProps) {
  return (
    <form className={twMerge('flex flex-col gap-6', className)} {...props} />
  )
}

interface FormHeaderProps extends ComponentProps<'div'> {}
function formHeader({ className, ...props }: FormHeaderProps) {
  return (
    <div
      className={twMerge(
        'text-monochromatic-500 flex flex-col gap-1',
        className,
      )}
      {...props}
    />
  )
}

interface FormUploadFileProps extends ComponentProps<'label'> {
  hasError?: boolean
}
function formUploadFile({
  className,
  hasError = false,
  ...props
}: FormUploadFileProps) {
  return (
    <label
      className={twMerge(
        'flex cursor-pointer items-center gap-4 rounded-lg border border-transparent p-4',
        'bg-monochromatic-200 text-monochromatic-400',
        'aria-disabled:cursor-not-allowed aria-disabled:opacity-60',
        hasError && 'border border-red-400',
        className,
      )}
      {...props}
    >
      <Circle className="size-6 rounded-full bg-[#D9D9D9] text-[#D9D9D9]" />
      <span className="flex-1 truncate">Faça o upload do arquivo</span>
      <FileUp className="size-6" />
    </label>
  )
}

interface ListInputRootProps extends ComponentProps<'input'> {}
function listInputRoot({ className, ...props }: ListInputRootProps) {
  return (
    <input
      multiple
      type="file"
      className={twMerge('sr-only', className)}
      accept="application/pdf"
      {...props}
    />
  )
}

interface ListFileRootProps extends ComponentProps<'div'> {}
function listFileRoot({ className, ...props }: ListFileRootProps) {
  return (
    <div
      className={twMerge('flex flex-col items-start gap-4', className)}
      {...props}
    />
  )
}

interface ListFileContentProps extends ComponentProps<'div'> {
  fileName: string
  handleRemoveJustificationFile(): void
  handleOpePaymentJustification: () => Promise<void>

  url: string
  isShowRemoveButton?: boolean
  isLoadingJustificationUrl: boolean
  isEditing: boolean
}
function listFileContent({
  url,
  className,
  fileName,
  handleRemoveJustificationFile,
  isLoadingJustificationUrl,
  isEditing,
  isShowRemoveButton = false,
  handleOpePaymentJustification,
  ...props
}: ListFileContentProps) {
  return (
    <div
      className={twMerge(
        'bg-bios-primary/20 flex w-full items-center gap-4 rounded-lg p-4',
        className,
      )}
      {...props}
    >
      <CheckCircle className="text-alert-success size-5 md:size-6" />
      <span className="text-monochromatic-400 flex-1 truncate">{fileName}</span>
      <div className="flex items-center gap-4">
        {isShowRemoveButton && (
          <Trash2
            onClick={handleRemoveJustificationFile}
            className="text-monochromatic-400 size-5 cursor-pointer md:size-6"
          />
        )}

        {isEditing ? (
          isLoadingJustificationUrl ? (
            <LoaderCircle className="text-monochromatic-400" />
          ) : (
            <Eye
              onClick={handleOpePaymentJustification}
              className="text-monochromatic-400 size-5 cursor-pointer md:size-6"
            />
          )
        ) : (
          <a href={url} target="_blank" rel="noopener noreferrer">
            <Eye className="text-monochromatic-400 size-5 cursor-pointer md:size-6" />
          </a>
        )}
      </div>
    </div>
  )
}

export const PaymentJustificationForm = {
  Root: formRoot,
  Header: formHeader,
  UploadFile: formUploadFile,
  ListInputRoot: listInputRoot,
  ListFileRoot: listFileRoot,
  ListFileContent: listFileContent,
}
